<template>
    <div>
        <Title title="在线充值" path="/my"/>

<!--        <div class="paybox">-->
<!--            <div class="paytit"><i></i>数字货币（USDT）</div>-->
<!--            <div class="payusdt">-->
<!--                <span><i/>USDT</span>-->
<!--                <button type="button" @click="getusdt">获取充值地址</button>-->
<!--            </div>-->
<!--            <div class="payusdt-tips">注意：务必使用波场TRC20公链USDT地址进行充值，否则无法找回概不负责！</div>-->
<!--            <div class="banktips">-->
<!--                <div class="tit">USDT充值优惠活动</div>-->
<!--                <p class="t">1、单次充值满<b>200</b> USDT送<b>10%</b></p>-->
<!--                <p>例：充值200 USDT*6.4 (汇率)=1280元，预计到账 1280<em>FXB</em>+128<em>积分</em>  (汇率按国际行情实时变化)；</p>-->
<!--                <p class="t">2、单次充值满<b>500</b> USDT送<b>15%</b></p>-->
<!--                <p>例：充值500 USDT*6.4 (汇率)=3200元，预计到账 3200<em>FXB</em>+480<em>积分</em>  (汇率按国际行情实时变化)；</p>-->
<!--                <p class="t">3、单次充值满<b>1000</b> USDT（或以上）送<b>20%</b></p>-->
<!--                <p>例：充值1000 USDT*6.4 (汇率)=6400元，预计到账 6400<em>FXB</em>+1280<em>积分</em>  (汇率按国际行情实时变化)；</p>-->
<!--            </div>-->
<!--        </div>-->

<!--        <template v-if="showPay || isWhite">-->
        <template v-if="showZFB || showWX">
        <div class="paybox">
            <div class="paytit"><i></i><em class="wechat"></em>即时充值</div>
            <div class="zfbpnl zfbpnlp1">
                <div class="zfbbx">
                    <div class="tit">选择方式</div>
<!--                    <ul>-->
<!--                        <li v-if="white_zfb">-->
<!--                            <span data-type="1" :class="zftype===1?'payt paytem':'payt'" @click="changePayType(1)"><i class='zfb'></i>支付宝-->
<!--                                <div class="icc"><span class="tu"></span><span class="bg"></span></div>-->
<!--                            </span></li>-->
<!--                        <li v-if="white_wx">-->
<!--                            <span data-type="2" :class="zftype===2?'payt paytem':'payt'" @click="changePayType(2)"><i class='wx'></i>微信-->
<!--                                <div class="icc"><span class="tu"></span><span class="bg"></span></div></span></li>-->

<!--&lt;!&ndash;                        <li>&ndash;&gt;-->
<!--&lt;!&ndash;                        <span data-type="1" :class="zftype===1?'payt paytem':'payt'" @click="changePayType(1)"><i class='zfb'></i>支付宝&ndash;&gt;-->
<!--&lt;!&ndash;                            <div class="icc"><span class="tu"></span><span class="bg"></span></div>&ndash;&gt;-->
<!--&lt;!&ndash;                        </span></li>&ndash;&gt;-->
<!--                    </ul>-->
                    <ul>
                        <li v-if="showZFB">
                            <span data-type="1" :class="zftype===1?'payt paytem':'payt'" @click="changePayType(1)"><i class='zfb'></i>支付宝
                                <div class="icc"><span class="tu"></span><span class="bg"></span></div>
                            </span></li>
                        <li v-if="showWX">
                            <span data-type="2" :class="zftype===2?'payt paytem':'payt'" @click="changePayType(2)"><i class='wx'></i>微信
                                <div class="icc"><span class="tu"></span><span class="bg"></span></div></span></li>
                    </ul>
                </div>
                <div class="zfbbx">
                    <div class="tit">选择金额</div>
                    <ul>
                        <li>
                    <span data-amt="500" :class="['amt amtn amtm', zfsel===1?' amtsel':'']" @click="changePayAmt(1, 500)">500元
                        <div class="icc"><span class="tu"></span><span class="bg"></span></div>
                    </span></li>
                        <li>
                    <span data-amt="1000" :class="['amt amtm', zfsel===2?' amtsel':'']" @click="changePayAmt(2, 1000)">1000元<em>赠送<b>100</b><i>积分</i></em>
                        <div class="icc"><span class="tu"></span><span class="bg"></span></div></span></li>
                        <li>
                    <span data-amt="2000" :class="['amt amtm', zfsel===3?' amtsel':'']" @click="changePayAmt(3, 2000)">2000元<em>赠送<b>200</b><i>积分</i></em>
                        <div class="icc"><span class="tu"></span><span class="bg"></span></div></span></li>
                        <li>
                    <span data-amt="3000" :class="['amt amtm', zfsel===4?' amtsel':'']" @click="changePayAmt(4, 3000)">3000元<em>赠送<b>450</b><i>积分</i></em>
                        <div class="icc"><span class="tu"></span><span class="bg"></span></div></span></li>
                        <li>
                            <div class="zdy">
                                <input type="number" min="1" max="3000" v-model="zfamt" @input="changeAmt" placeholder="自定义金额"/>
<!--                                <span>元</span>-->
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="zfbbx">
                    <div class="tit">预计到账</div>
                    <div class="sjdz">
                        <div class="dian"><span>{{sjamt}}</span><em>FXB</em></div>
                        <div class="jifn" id="sjjfsp" v-if="zsamt>0">+ <span id="sjjfnum">{{zsamt}}</span><em>积分</em></div>
                    </div>
                    <button class="zfbpay" @click="getThrPay">确认支付</button>
                </div>
            </div>
            <div class="banktips banktips2">
                <div class="tit">充值说明</div>
                <p>1.充值比例<b>1元=1<em>FXB</em></b>，1积分可抵扣1FXB。</p>
                <p>2.支付宝/微信充值限额为1-3000元。</p>
            </div>
        </div>
        </template>
<!--        </template>-->

        <div class="paybox">
            <div class="paytit"><i></i>转账汇款<p>向客服索取账号，汇款时请多汇点零头，以方便确认</p></div>
            <div class="paybank">
                <div class="bankpic">
                    <ul>
                    <li><div><img src="../../assets/images/bank/bankccb.gif"/></div></li>
                        <li><div><img src="../../assets/images/bank/bankicbc.gif"/></div></li>
                        <li><div><img src="../../assets/images/bank/bankabc.gif"/></div></li>
                        <li><div class="pal"><img src="../../assets/images/bank/paypal.png"/></div></li>
                    </ul>
                </div>
            </div>
            <div class="banktips banktips2">
                <div class="tit">温馨提示</div>
                <p>1.充值比例<b>1元=1<em>FXB</em></b>，1积分可抵扣1FXB。</p>
                <p>2.推荐使用支付宝、微信支付在线充值，在线充值成功后，系统会自动为您即时增加额度，快速便捷，无需等待。</p>
                <p>3.凡一次性充满1000元及以上，额外赠送10%积分，多充多送。</p>
                <p>4.为便于识别汇款人，汇款时请多汇几分钱，比如充值1000元，可以汇1000.09、1000.22。</p>
                <p>5.银行汇款后请在第一时间联系我们，电话：<b>{{tel}}</b></p>
            </div>
        </div>

        <van-popup position="bottom" v-model="showPopup" @click-overlay='close' :duration=".1" v-if="usdt">
            <div class="fxconfdialog_bx fxconfdialog_usdt">
                <h2>
                    <span>USDT充值</span>
                    <i @click="close"></i>
                </h2>
                <div class="fxconfdialog_cn">
                    <div class="info">
                        <div class="img">
                            <img :src="usdt.imgurl">
                        </div>
                        <div class="rgn">
                            <div class="usdt">USDT | 波场TRON</div>
                            <div class="rate"><em>当前汇率：</em>1USDT = <span>{{ usdt.rate }}<b>FXB</b></span></div>
                            <p>请扫码充值</p>
                        </div>
                    </div>
                    <div class="tips">注意：务必使用波场TRC20公链USDT地址进行充值<br/>否则无法找回概不负责！</div>
                    <div class="addr">
                        <div>{{ usdt.address }}</div>
                        <button :data-clipboard-text="usdt.address" id="usdtaddress" @click="copy">复制<span>地址</span></button>
                    </div>
                    <div class="tx">
                        <div>充值说明</div>
                        <p>如您充值100USDT，将到账<b>{{ usdt.rate * 100 }}</b><em>FXB</em></p>
                        <p>建议每次先充值1USDT，成功后再进行大额充值。</p>
                        <p>充值成功后10-15分钟到账，如未到账请联系客服。</p>
                    </div>
                </div>
            </div>
        </van-popup>

        <van-popup position="bottom" v-model="showThrPopup" @click-overlay='close' :duration=".1" v-if="ThrPayInfo">
            <div class="fxpoplogin">
                <h2>
                    <span>扫码支付</span>
                    <i @click="closeThr"></i>
                </h2>
                <div class="fxpoplogin-con fxpay-con">
                    <div class="amt">支付<span>{{sjamt}}</span>元</div>
                    <div class="img"><img :src="ThrPayInfo.code_url"/></div>
                    <div class="dsc" v-if="zftype===1">使用<span class="zfb">支付宝</span>扫一扫支付</div>
                    <div class="dsc" v-else>使用<span class="wx">微信</span>扫一扫支付</div>
                </div>
            </div>

        </van-popup>


    </div>
</template>

<script>
    import '../../assets/css/user.css'
    import Title from '../public/title'
    import Clipboard from 'clipboard'
    export default {
        name: "recharge",
        components: {
            Title
        },
        data (){
            return {
                tel: this.$getContactTel(),
                showPopup: false,
                usdt: null,
                showPay: false,
                showZFB: false,
                showWX: false,
                isWhite: false,
                white_wx: false,
                white_zfb: false,

                zftype: 1,
                zfsel: 3,
                zfamt: '',
                sjamt: 2000,
                zsamt: 200,
                showThrPopup: false,
                ThrPayInfo: null,
                timer: null,
                payTimeout: 60*3, //支付超时 3分钟

                pay_wx_quota: 0,
                pay_zfb_quota: 0
            }
        },
        watch: {

        },
        activated() {
            let that = this
            this.$post(that.$api.member_payInfo, {url: window.location.href}).then(function (res) {
                if(res.code === 1){
                    // that.showPay = res.data.showPay
                    // that.isWhite = res.data.isWhite
                    that.showZFB = res.data.showzfb
                    that.showWX = res.data.showwx
                    that.pay_wx_quota = res.data.pay_wx_quota
                    that.pay_zfb_quota = res.data.pay_zfb_quota
                    // that.white_wx = res.data.white_wx
                    // that.white_zfb = res.data.white_zfb
                    // if(that.isWhite === true){
                    //     that.zftype = 1
                    //     if(that.white_zfb === false && that.white_wx === true)
                    //         that.zftype = 2
                    // }
                    // else
                    if(that.showZFB)
                        that.zftype = 1
                    else if(that.showWX)
                        that.zftype = 2
                }
            })
        },
        deactivated() {
            let that = this
            clearInterval(that.timer)
            that.timer = null
        },
        methods: {
            close(){
              this.showPopup = false
            },
            getusdt(){
                let that = this
                that.$post(that.$api.member_getusdt).then(function (res) {
                    if (res.code === 1) {
                        that.showPopup = true
                        that.usdt = res.data
                    }
                })
            },
            copy(){
                let that = this
                let clipboard = new Clipboard('#usdtaddress');
                clipboard.on('success', function(e) {
                    that.$toast.success('复制成功!')
                    e.clearSelection()
                })
                clipboard.on('error', function() {
                    that.$toast.fail('请选择“拷贝”进行复制!')
                })
            },
            closeThr(){
                let that = this
                that.showThrPopup = false
                clearInterval(that.timer)
                that.timer = null
            },
            changePayAmt(t, amt, s=true){
                this.zfsel = t
                if(s)
                    this.zfamt = ''
                let zs = 0
                if(amt>=1000&&amt<3000)
                    zs = parseInt(amt*0.1)
                else if(amt>=3000)
                    zs = parseInt(amt*0.15)

                this.sjamt = amt
                this.zsamt = zs
            },
            changeAmt(e){
                // console.log(e.currentTarget.value)
                if(e.currentTarget.value === '')
                    this.sjamt = 0
                else
                    this.sjamt = e.currentTarget.value
                this.changePayAmt(this.zfsel, this.sjamt, false)
            },
            changePayType(i){
                this.zftype = i
            },
            getThrPay(){
                let that = this
                if(that.sjamt === 0) return
                let quota = 3000
                if(parseInt(that.zftype) === 1)
                    quota = that.pay_zfb_quota
                else if(parseInt(that.zftype) === 2)
                    quota = that.pay_wx_quota
                if(that.sjamt < 0 || that.sjamt > quota) {
                    that.$toast('充值金额限额'+quota+'元')
                    return
                }
                that.$post(that.$api.member_getpaytre, {type: that.zftype, amt: that.sjamt}).then(function (res) {
                    if (res.code === 1) {
                        that.showThrPopup = true
                        that.ThrPayInfo = res.data
                        let order_no = res.data.order_no
                        //循环读取订单状态
                        let timeout = 0
                        that.timer = setInterval(function () {
                            timeout += 8
                            //支付超时 关闭
                            if(timeout>=that.payTimeout){
                                clearInterval(that.timer)
                                that.showThrPopup = false
                                that.ThrPayInfo = null
                                return
                            }
                            that.$post(false, that.$api.member_getpaytre_status, {trade_no: order_no}).then(function (res) {
                                if(res.code === 10) {
                                    clearInterval(that.timer)
                                    that.showThrPopup = false
                                    that.ThrPayInfo = null
                                    that.$toast.success('支付成功')
                                }
                            })

                        }, 1000 * 8)
                    }
                    else{
                        that.$toast.fail('请求失败，请稍后再试')
                    }
                })
            }
        },
    }
</script>

<style scoped>

</style>
